"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC = void 0;

var TranscriptEvent_1 = require("./TranscriptEvent");

exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC = 'aws:chime:transcription';

var DefaultTranscriptionController = /*#__PURE__*/function () {
  function DefaultTranscriptionController(realtimeController) {
    _classCallCheck(this, DefaultTranscriptionController);

    this.realtimeController = realtimeController;
    this.transcriptEventCallbacks = new Set();
  }

  _createClass(DefaultTranscriptionController, [{
    key: "subscribeToTranscriptEvent",
    value: function subscribeToTranscriptEvent(callback) {
      var _this = this;

      if (this.transcriptEventCallbacks.size === 0) {
        this.realtimeController.realtimeSubscribeToReceiveDataMessage(exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC, function (dataMessage) {
          var _iterator = _createForOfIteratorHelper(TranscriptEvent_1.TranscriptEventConverter.from(dataMessage)),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var transcriptEvent = _step.value;

              var _iterator2 = _createForOfIteratorHelper(_this.transcriptEventCallbacks),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var transcriptEventCallback = _step2.value;
                  transcriptEventCallback(transcriptEvent);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }

      this.transcriptEventCallbacks.add(callback);
    }
  }, {
    key: "unsubscribeFromTranscriptEvent",
    value: function unsubscribeFromTranscriptEvent(callback) {
      this.transcriptEventCallbacks.delete(callback);

      if (this.transcriptEventCallbacks.size === 0) {
        this.realtimeController.realtimeUnsubscribeFromReceiveDataMessage(exports.TRANSCRIPTION_DATA_MESSAGE_TOPIC);
      }
    }
  }]);

  return DefaultTranscriptionController;
}();

exports.default = DefaultTranscriptionController;